import IndexManager from "../index-manager";
import debuggingProps from "./index.debug";
import { handlePreview } from "./index.preview";
import { debounce } from "lodash";

(async function() {

  /* ***************** */
  /*     Settings      */
  /* ***************** */

  const manager = new IndexManager('rt', {
    // Exclusive Params
    'rt_theme': 'default',
    'rt_font': 'default',
    'rt_showsuppmsg': 'true',
    'rt_txtshadow': 'false',
    'rt_speed': 'normal',
    'rt_count': 3,
    'rt_interval': 7,
    'rt_type': 'latest-tips',
    'rt_messages': '',
    'rt_septype': 'image',
    'rt_message_delay': 10,

    // Colors: Default
    'rt_1_clr1': '#be1e2d',
    'rt_1_clr2': '#ffffff',
    'rt_1_clr3': '#ffc849',

    // Colors: Retro
    'rt_2_clr1': '#fbfbfb',
    'rt_2_clr2': '#000',
    'rt_2_clr3': '#be1e2d',
    'rt_2_clr4': '#262522',

    // Colors: Transitional
    'rt_3_clr1': '#444444',
    'rt_3_clr2': '#fff',
    'rt_3_clr3': '#FBD758',

    // Exclusive Ramadhan
    'rt_show_link': 'false',
  });

  /* ***************** */
  /*  Widget Behavior  */
  /* ***************** */
 
  class TrWidget {

    data = {};
    setting = {};
    theme = '';

    messageBuilder = [];
    tipsQueue = [];
    marq = null;
    rate = -75;
    $marquee = null;
    marquee = null;

    // simulationRIS = 0;
    // simulationListSupporter = [];

    exclusiveTheme = ['ramadhan'];

    limit() {
      var limit = this.setting['rt_count'] ? parseInt(this.setting['rt_count']) : 3;
      limit = limit > 10 ? 10 : limit;
      limit = limit < 1  ? 1  : limit; 
      return limit
    }

    interval() {
      var interval = this.setting['rt_interval'] ? parseInt(this.setting['rt_interval']) : 7;
      interval = interval < 1  ? 1 : interval;
      return interval;
    }

    messageDelay() {
      let delay = this.setting['rt_message_delay'] ? parseInt(this.setting['rt_message_delay']) : 0.1;
      return delay *1000;
    }

    async setup(themeSetting, themeProps) {
      this.setting = themeSetting;
      this.theme = themeProps[this.setting['rt_theme']];
      await this.theme.setup(this.setting);
      this.applyStyle();

      this.setupMarquee();

      if (this.exclusiveTheme.includes(this.theme.name)) {
        //execute exclusive setup
        if (typeof this.theme.exclusiveSetup === "function") {
          this.theme.exclusiveSetup()
        }
      }
    }

    async setupMarquee() {
      this.$marquee = h.el('#marquee');
      this.$marquee.classList.add(this.setting['rt_type']);
      await this.setupRate();
      this.marquee = (window.m = new dynamicMarquee.Marquee(this.$marquee, { rate: this.rate }));
    }

    async setupRate() {
      if (!this.setting['rt_speed'] || this.setting['rt_speed'] == 'normal') {
        this.rate = -75;
      } else if (this.setting['rt_speed'] == 'slow') {
        this.rate = -50;
      } else if (this.setting['rt_speed'] == 'fast') { 
        this.rate = -100;
      } else if (this.setting['rt_speed']== 'faster') { 
        this. rate = -125;
      }
    }
    /* Styling */

    applyStyle() {
      // Set Styles
      const styles = this.theme.styles();
      for (let i = 0; i < styles.length; i++) {
        const style = styles[i];
        h.setThemeVar(style.var, this.setting[style.key] || style.default);
      }
      // Set Fonts
      const reqFont = this.setting['rt_font'] || 'default';
      h.setThemeVar(
        this.theme.font().var,
        reqFont === 'default' ? this.theme.font().default : "'" + reqFont + "'"
      );

      //for default theme, set shadow effect option
      if(this.setting['rt_theme'] == 'default' && h.isTrue(this.setting['rt_txtshadow'])) {
        let shadows = this.theme.stylesTextShadow();
        for (let i = 0; i < shadows.length; i++) {
          const shadow = shadows[i];
          h.setThemeVar(shadow.var, shadow.default);
        }
      }
    }

    /* Animation Logic */

    reset(data) {
      this.data = data;
    }

    createItem() {
      let el = document.createElement('div');
      el.innerHTML = this.theme.html().trim();
      return el;
    }

    async addItem(el) {
      this.messageBuilder.push(function() {
        let msg = el;
        return msg;
      });
    }
    
    async prependItem(el) {
      this.messageBuilder.unshift(function() {
        let msg = el;
        return msg;
      });
    }

    setAnimationData(el) {
      if (!this.theme) return;
      if (!this.setting) {
        console.debug('Applied setting not found');
        return;
      }

      this.theme.setData(el, this.data);
    }

    async showAnimation(el) {
      if (!this.theme) return;
      if (!this.setting) {
        console.debug('Applied setting not found');
        return;
      }

      this.addItem(el);
    }

     /* Marquee Function */

    runDynamicMarquee(messageBuilder) {
      let self = this
      this.marq = dynamicMarquee.loop(
        this.marquee,
        messageBuilder,
        function () {
          var $separator = document.createElement('div');
          var img = `<div class='separator-bull'>&bull;</div>`;
          if(self.setting['rt_theme'] == 'default' && self.setting['rt_septype'] == 'image') {
            // img = `<img class='separator-image' src="https://edge-cdn.trakteer.id/images/mix/trakteer-icon-fitted.png">`;
            img = `<svg class="separator-image" width="20" height="20" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 64V76C0 106.17 0 121.255 9.37258 130.627C18.7452 140 33.8301 140 64 140H76C106.17 140 121.255 140 130.627 130.627C140 121.255 140 106.17 140 76V64C140 33.8301 140 18.7452 130.627 9.37258C121.255 0 106.17 0 76 0H64C33.8301 0 18.7452 0 9.37258 9.37258C0 18.7452 0 33.8301 0 64ZM75.6797 31.2342C75.804 31.7613 75.438 32.2615 74.9146 32.4004C69.7823 33.762 66 38.4393 66 44C66 44.2837 66.0098 44.565 66.0292 44.8438C66.0667 45.3841 65.7113 45.8912 65.1722 45.9435C64.7865 45.9809 64.3955 46 64 46C57.3726 46 52 40.6274 52 34C52 27.3726 57.3726 22 64 22C69.6755 22 74.4308 25.9401 75.6797 31.2342ZM85.0017 50C85.6308 50 86.2344 49.7105 86.5603 49.1724C87.4741 47.6631 88 45.8937 88 44C88 38.4766 83.5229 34 78 34C72.477 34 68 38.4766 68 44C68 45.8937 68.5259 47.6631 69.4397 49.1724C69.7655 49.7105 70.3692 50 70.9983 50H85.0017ZM48.3132 60.1623C47.7609 60.3246 47.4415 60.5301 46.8028 60.9411C46.4742 61.1525 46.1579 61.3789 45.8497 61.6318C45.0396 62.2967 44.2967 63.0396 43.6318 63.8497C40 68.2751 40 74.8501 40 88C40 101.15 40 107.725 43.6318 112.15C44.2967 112.96 45.0396 113.703 45.8497 114.368C50.2751 118 56.8501 118 70 118C83.1499 118 89.7249 118 94.1503 114.368C94.9604 113.703 95.7033 112.96 96.3682 112.15C100 107.725 100 101.15 100 88C100 74.8501 100 68.2751 96.3682 63.8497C95.7033 63.0396 94.9604 62.2967 94.1503 61.6318C92.6238 60.3791 90.8416 59.5585 88.622 59.0209C89.4662 58.2875 90 57.2061 90 56C90 53.7909 88.2092 52 86 52H54C51.7909 52 50 53.7909 50 56C50 56.9227 50.3125 57.7725 50.8373 58.4493C51.0166 58.6804 51.1062 58.796 51.3144 58.898C51.5226 59 51.7186 59 52.1106 59H63.5C63.7761 59 64 59.2239 64 59.5C64 59.7761 63.7761 60 63.5 60H50.4032C49.3781 60 48.8655 60 48.3132 60.1623Z" fill="var(--defaultMarqueeTextColor)"/>
                <path d="M70.805 74.7665C70.381 75.1531 69.7137 75.1534 69.29 74.7664C59.7285 66.0333 48.0521 79.8885 57.4848 89.8359L67.2631 99.3037C68.8149 100.806 71.2795 100.805 72.8302 99.3015L82.567 89.8589C91.9063 80.0045 80.2391 66.1633 70.805 74.7665Z" fill="var(--defaultMarqueeTextColor)"/>
              </svg>`;
          }
          else if( self.setting['rt_theme'] == 'ramadhan' && self.setting['rt_septype'] == 'image'){
            img = `<img class='separator-image' src="https://edge-cdn.trakteer.id/images/mix/trakteer-icon-ramadhan.png">`;
          }
          $separator.innerHTML = img;
          return $separator;
        }
      );
    }
    pause() {
      if(this.marquee) {
        this.marquee.setRate(0);
      }
    }
    play() {
      if(this.marquee) {
        this.marquee.setRate(this.rate);
      }

    }
  }

  /* ***************** */
  /*   Widget Manager  */
  /* ***************** */

  IndexManager.prototype.addRunningText = async function(data, params = {}) {
    this.widget.reset(data);
    let item = this.widget.createItem();
    this.widget.setAnimationData(item);
    if(!params.isPrepend) {
      await this.widget.showAnimation(item);
    } else {
      await this.widget.prependItem(item)
    }
  }

  IndexManager.prototype.addMsgOnHead = async function() {
    let self = this;
    this.widget.messageBuilder.push(function() {
      return self.widget.theme.fnExtraMessageOnHead();
    });
  }

  IndexManager.prototype.addMsgOnTail = async function() {
    let self = this;
    let creatorName = h.args('creator_name') || "Creator";
    this.widget.messageBuilder.push( function() {
      return self.widget.theme.fnExtraMessageOnTail(creatorName, h.args('page_url'));
    });
  }

  IndexManager.prototype.runMarquee = async function() {
    this.widget.runDynamicMarquee(this.widget.messageBuilder);
  }

  IndexManager.prototype.updateMarquee = async function() {
    this.widget.marq.update(this.widget.messageBuilder);
  }

  IndexManager.prototype.reloadHandler = debounce((data) => {
    manager.getTopSupporter({isUpdate: true})
  }, 500, { 'maxWait': 1000 });

  IndexManager.prototype.updateLatestTips = async function() {
    let self = this;
    window.setInterval(function() {
      if (self.widget.tipsQueue.length <= 0) {
        return;
      }

      var itemLength = self.widget.messageBuilder.length;
      if (itemLength >= self.widget.limit() + 1 ) {
        self.widget.messageBuilder.splice(itemLength - 2, 1);
      }
      
      var tipData = self.widget.tipsQueue[0];
      self.addRunningText(tipData, {isPrepend: true})
      self.widget.tipsQueue.splice(0, 1);

      /* Update Running Text Data */
      self.updateMarquee();
    }, this.widget.messageDelay());
  }

  IndexManager.prototype.getShowMessage = function() {
    if(this.widget.setting.rt_type === "latest-tips") {
      return (String(this.widget.setting.rt_showsuppmsg).toLowerCase() === 'true')
    } else {
      return false
    }
  }

  /* ***************** */
  /*      API Call     */
  /* ***************** */

  IndexManager.prototype.loadData = async function() {
    if(this.widget.setting['rt_type'] == 'top-supporters') {
      manager.getTopSupporter();
    } else {
      manager.getLatestTips();

      manager.updateLatestTips()
    }
  }

  IndexManager.prototype.getLatestTips = async function() {
    let self = this;
    superagent
    .get(this.apiUrl(`stream/${this.key}/latest-tips`))
    .query({ limit: this.widget.limit() }) 
    .accept('application/json')
    .end(async function (err, res) {

      try {
        var dataSupporter = res.body.latestTip;

        if (dataSupporter.length > 0) {
          dataSupporter.forEach(function(data,index) {
            var temp = {
              supporter: data,
              icon: res.body.unitIcon,
              unitName: res.body.unitName,
              pageUrl: res.body.pageUrl
            }
            
            self.addRunningText(temp);
          });
        }

        if (dataSupporter.length > 0 || (dataSupporter.length == 0 && self.widget.messageBuilder.length <= 0)) {
          await self.addMsgOnTail();
          self.runMarquee()
        }
      } catch (err) {
        // console.log(err); 
        return null;
      }
    });
  }
  IndexManager.prototype.getTopSupporter = async function(params = {}) {
    let self = this;
    superagent
    .get(this.apiUrl(`stream/${this.key}/top-supporters`))
    .query({ interval: this.widget.interval() }) 
    .query({ count: this.widget.limit() }) 
    .accept('application/json')
    .end(async function (err, res) {
      
      try {
        var data = res.body.supporter;

        if(data.length > 0 ) {
          /* Reset Message Builder If There's An Updates */
          if (params.isUpdate) {
            self.widget.messageBuilder = [];
          }

          await self.addMsgOnHead()

          data.forEach(function(data,index) {
            var temp = {
              no: index + 1,
              supporter: data,
              icon: res.body.unitIcon,
              unitName: res.body.unitName,
              pageUrl: res.body.pageUrl
            }
            
            self.addRunningText(temp);
          });
        }

        if (data.length > 0 || (data.length == 0 && self.widget.messageBuilder.length <= 0)) {
          await self.addMsgOnTail()

          if (params.isUpdate) {
            self.updateMarquee()
          } else {
            self.runMarquee()
          }
        }
      } catch (err) {
        // console.log(err);
        return null;
      }
    });
  }

  /* ***************** */
  /*     Websocket     */
  /* ***************** */

  function setupListener() {
    manager.addListenerOn('new-tip', function(data) {
      if(manager.widget.setting['rt_type'] == 'top-supporters') {
        manager.reloadHandler(data)
      } else {
        let temp = {
          supporter: {
            display_name: data.supporter_name,
            quantity: data.quantity,
            support_message: data.supporter_message
          },
          icon: `<img src="${data.unit_icon}" width="20px" height="20px"/>`,
          unitName: data.unit,
          pageUrl: "-"
        }
        manager.widget.tipsQueue.push(temp);
      }
    });

    manager.addListenerOn('new-tip-simulation', function(data) {
      if(manager.widget.setting['rt_type'] == 'top-supporters') {
        manager.reloadHandler(data)
      } else {
        let temp = {
          supporter: {
            display_name: data.supporter_name,
            quantity: data.quantity,
            support_message: data.supporter_message
          },
          icon: `<img src="${data.unit_icon}" width="20px" height="20px"/>`,
          unitName: data.unit,
          pageUrl: "-"
        }

        manager.widget.tipsQueue.push(temp);
      }
    });
  }

  /* ***************** */
  /*       Init        */
  /* ***************** */

  await manager.init({
    widget: new TrWidget(),
    debug: debuggingProps,
    preview: handlePreview
  });
  setupListener();
})();